<template>
  <my-case-section-core no-padding>
    <template #header>
      <div class="mb-lg mb-lg-xl">
        <p
          v-if="hasRentalPlan"
          class="small-text mb-0">
          Drop your returns in the mail <span
            v-if="showTodayReturns"
            class="semi-bold">
            today.
          </span>
          <span v-else>within 24 hours of receiving your new Case.</span>
        </p>
        <p
          v-else
          class="small-text mb-0">
          Drop your returns in the mail today.
        </p>
        <text-link
          v-if="active && hasRentalPlan"
          variant="primary"
          class="mx-1"
          @click="setMyCaseFlyoutName('edit-returns')">
          Edit Return Items
        </text-link>
      </div>
    </template>
    <template #body>
      <div>
        <CaseItem
          v-for="(item, idx) in toReturnItems"
          :key="item.id"
          class="p-md border-bottom"
          :class="{'border-top': idx === 0 }"
          :package-item="item"
          :is-returning="true"
          :show-buy-button="hasRentalPlan"
          :show-review-button="hasRentalPlan">
          <template
            v-if="getStyleColor(item.item).style.hasBelt"
            #extraInfo>
            Don't forget to include this item's matching belt with your return
          </template>
        </CaseItem>
      </div>
      <FedExCaseCTA
        v-if="fedexPreferred && !isSeattleLocal && !recentFedexPickup"
        class="mt-md"
        source="returns"/>
    </template>
  </my-case-section-core>
</template>

<script>
import MyCaseSectionCore from '../common/MyCaseSectionCore'
import MyCaseMixin from '../common/MyCaseMixin'
import CaseItem from '@/components/case/caseItem/CaseItem.vue'
import TextLink from '../../global/sequin/TextLink'
import FedExCaseCTA from '../fedEx/FedExCaseCTA.vue'
import { mapActions as mapVuexActions, mapState } from 'vuex'
import { storeToRefs } from 'pinia'
import { StyleColorMixin } from '../../styleColorSet/StyleColorMixin'
import { useFedExOptInStore } from '@/stores/fedExOptIn'
import { useReturnCarrier } from '@/composables/returnCarrier.js'

export default {
  components: {
    CaseItem,
    MyCaseSectionCore,
    FedExCaseCTA,
    TextLink
  },
  mixins: [MyCaseMixin, StyleColorMixin],
  setup () {
    const { isSeattleLocal, fedexPreferred } = useReturnCarrier()
    const { recentFedexPickup } = storeToRefs(useFedExOptInStore())
    return {
      isSeattleLocal,
      fedexPreferred,
      recentFedexPickup
    }
  },
  computed: {
    ...mapState('account', [
      'returnLabelLink'
    ]),
    showTodayReturns () {
      return this.deliveredItems.length > 0 || this.primaryCaseState === 'awaiting-returns'
    }
  },
  methods: {
    ...mapVuexActions('case', [
      'setMyCaseFlyoutName'
    ]),
    getStyleColor (item) {
      return this.styleColorsMap[item.styleColor]
    }
  }
}
</script>
